// extracted by mini-css-extract-plugin
export var attachment = "_ou-a";
export var emailContainer = "_ou-4";
export var emailContentPaddedContainer = "_ou-b";
export var emailHeader = "_ou-6";
export var emailIframe = "_ou-3";
export var emailInfoIcon = "_ou-9";
export var emailShortenedSummary = "_ou-e";
export var infoDropdown = "_ou-0";
export var infoRowBoundedContent = "_ou-d";
export var internal = "_ou-5";
export var merchant = "_ou-8";
export var messageInputContainer = "_ou-h";
export var normal = "_ou-7";
export var replyCard = "_ou-f";
export var subtleButton = "_ou-1";
export var subtleButtonIconContainer = "_ou-2";
export var toggleViewRepliesButton = "_ou-c";
export var wrappingText = "_ou-g";